import Vue from 'vue';

Vue.mixin({
  created () {
    this.$isMobile   = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
    this.$isGoNative = navigator.userAgent.indexOf('gonative') > -1;
  }
});

Vue.mixin({
  created () {
    this.$mixpanel = window.mixpanel;

    if (process.env.NODE_ENV === 'development') {
      this.$mixpanel.disable();
    }
  }
});

Vue.mixin({
  created () {
    this.$showAds = ['production', 'development'].includes(process.env.NODE_ENV);
    
    this.$refreshAds = (clear = false) => {
      if (!this.$root.$revived) {
        return;
      }

      if (clear) {
        for (const item of document.querySelectorAll('ins[data-revive-loaded]')) {
          item.removeAttribute('data-revive-loaded');
        }
      }

      const key = Object.keys(window.reviveAsync)[0];
      window.reviveAsync[key].apply(window.reviveAsync[key].detect());
      for (const item of document.querySelectorAll('ins[data-revive-seq]')) {
        item.style.display = 'block';
        item.parentElement.style.display = 'block'; // no idea why its set to display: none
      }
    };
  },
  mounted () {
    this.$refreshAds();
  }
});

Vue.mixin({
  created () {
    this.$ikImg = function (src, options = {}) {
      const trs = ['rt-auto', 'dpr-2.0'];

      if (options.width && options.width > 0) {
        trs.push('w-' + options.width);
      }

      if (options.height && options.height > 0) {
        trs.push('h-' + options.height);
      }

      if (options.smart) {
        trs.push('fo-auto');
      }

      if (options.extra) {
        trs.push(options.extra);
      }

      if (/imagekit/.test(src)) {
        if (!/tr:/.test(src)) {
          src = src.replace('geartester/', 'geartester/tr:' + trs.join(',') + '/');
          src = src.replace('gunfinder/', 'gunfinder/tr:' + trs.join(',') + '/');
        } else {
          // jagdzeit
          // src = src.replace(/tr:[^/]+/, 'tr:w-320' + trs.join(',') + '/');
          src = src.replace(/tr:[^/]+/, 'tr:h-210,dpr-2.0' + '/');
        }

        return src;
      }

      // const path = (!options.direct ? '/tr:' + trs.join(',') : '') + '/' + src;

      // return 'https://ik.imagekit.io/outleap' + (options.direct ? '/tr:' + trs.join(',') : '') + '/jagdnews-proxy/' + path;

      let endpoint;
      if (/^https?:\/\//.test(src)) {
        endpoint = 'jagdnews-proxy';
        src = encodeURIComponent(src);
      } else {
        endpoint = 'jagdnews';
      }

      return `https://ik.imagekit.io/outleap/${endpoint}/${src}?tr=${trs.join(',')}`;
    };
  }
});
